import { render, staticRenderFns } from "./file-table.vue?vue&type=template&id=1858835c&"
import script from "./file-table.vue?vue&type=script&lang=js&"
export * from "./file-table.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports